import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { RefreshCw, Rocket } from "lucide-react";

export function UpdateBanner({ onUpdate }) {
  return (
    <Box
      position="fixed"
      bottom={6}
      right={6}
      zIndex="banner"
      w="320px"
      borderRadius="xl"
      overflow="hidden"
      boxShadow="0 20px 60px rgba(0,0,0,0.18), 0 4px 16px rgba(0,0,0,0.1)"
      border="1px solid"
      borderColor="gray.100"
      bg="white"
      sx={{
        animation: "slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards",
        "@keyframes slideUp": {
          "0%": { opacity: 0, transform: "translateY(32px)" },
          "100%": { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      {/* Gradient hero area */}
      <Box
        px={5}
        pt={5}
        pb={4}
        bgGradient="linear(135deg, #4f46e5 0%, #7c3aed 60%, #a855f7 100%)"
        position="relative"
        overflow="hidden"
      >
        {/* Decorative circles */}
        <Box
          position="absolute"
          top="-20px"
          right="-20px"
          w="100px"
          h="100px"
          borderRadius="full"
          bg="whiteAlpha.100"
        />
        <Box
          position="absolute"
          bottom="-30px"
          right="40px"
          w="70px"
          h="70px"
          borderRadius="full"
          bg="whiteAlpha.100"
        />

        {/* Icon badge + label */}
        <Flex align="center" gap={3} position="relative">
          <Flex
            align="center"
            justify="center"
            w="38px"
            h="38px"
            borderRadius="xl"
            bg="whiteAlpha.200"
            backdropFilter="blur(8px)"
            border="1px solid"
            borderColor="whiteAlpha.300"
            flexShrink={0}
            sx={{
              animation: "rockIt 2.4s ease-in-out infinite",
              "@keyframes rockIt": {
                "0%, 100%": { transform: "rotate(-8deg)" },
                "50%": { transform: "rotate(8deg)" },
              },
            }}
          >
            <Rocket size={18} color="white" />
          </Flex>

          <Box>
            <Text
              fontSize="11px"
              fontWeight="700"
              letterSpacing="0.1em"
              textTransform="uppercase"
              color="whiteAlpha.700"
              lineHeight={1}
              mb="3px"
            >
              Update ready
            </Text>
            <Text fontSize="md" fontWeight="700" color="white" lineHeight={1.2}>
              New version available
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* Body */}
      <Flex direction="column" gap={4} px={5} py={4}>
        <Text fontSize="sm" color="gray.500" lineHeight="1.6">
          We've shipped improvements and fixes. Refresh to load the latest
          version.
        </Text>

        <Button
          onClick={onUpdate}
          size="md"
          w="full"
          h="40px"
          borderRadius="xl"
          color="white"
          fontWeight="700"
          fontSize="sm"
          letterSpacing="0.02em"
          leftIcon={<RefreshCw size={14} />}
          border="none"
          transition="all 0.18s ease"
          variant="primary"
        >
          Refresh now
        </Button>
      </Flex>
    </Box>
  );
}
